module.exports = __webpack_public_path__ + "img/bingo_ball-48.cad95d33.png";